import React from 'react';
import { useUiStateStore } from '@/stores/uiStateStore';
import { SceneLayer } from '@/components/SceneLayer/SceneLayer';
import { RenderLayer } from '@/core/renderer/types';
import { getTilePosition } from '@/utils';

export const SmartGuides: React.FC = () => {
  const guides = useUiStateStore((state) => state.smartGuides);
  if (!guides.length) return null;

  return (
    <SceneLayer order={RenderLayer.TRANSFORM_CONTROLS - 0.2} disableAnimation>
      {guides.map((guide, index) => {
        const padding = guide.from === guide.to ? 1 : 0.75;
        const start = guide.axis === 'X'
          ? { x: guide.value, y: guide.from - padding }
          : { x: guide.from - padding, y: guide.value };
        const end = guide.axis === 'X'
          ? { x: guide.value, y: guide.to + padding }
          : { x: guide.to + padding, y: guide.value };
        const from = getTilePosition({ tile: start });
        const to = getTilePosition({ tile: end });
        const width = Math.hypot(to.x - from.x, to.y - from.y);
        const angle = Math.atan2(to.y - from.y, to.x - from.x) * 180 / Math.PI;

        return (
          <div
            key={`${guide.axis}-${guide.value}-${index}`}
            className="absolute h-px origin-left border-t border-dashed border-fuchsia-500"
            style={{
              left: from.x,
              top: from.y,
              width,
              transform: `rotate(${angle}deg)`,
              pointerEvents: 'none',
              filter: 'drop-shadow(0 0 2px rgba(217, 70, 239, 0.55))'
            }}
          />
        );
      })}
    </SceneLayer>
  );
};
